import React, { useEffect, useState } from 'react';
import {
    Card,
    CardHeader,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Table,
    FormGroup,
    Label,
    Input,
    FormFeedback,
    Spinner,
    InputGroup
} from 'reactstrap';
import { updateJob } from 'service/cronjob.service';
import { getJobs } from 'service/cronjob.service';
import { deleteJob } from 'service/cronjob.service';
import { addNewCronjob } from 'service/cronjob.service';
import { getOfferStatus } from 'service/offerstatus.service';
import { deleteTrackingPanel } from 'service/trackingPanel.service';
import { updateTrackingPanel } from 'service/trackingPanel.service';
import { addTrackingPanel } from 'service/trackingPanel.service';
import { getTrackingPanels } from 'service/trackingPanel.service';



const Cronjobs = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [offerTypeData, setOfferTypeData] = useState([]);
    const [newCronjob, setNewCronjob] = useState({
       id: 0,
       title: "",
       schedule: "",
       hours: 0,
       minutes: 0,
       jobId: 0
    });
    const [jobslist, setJobs] = useState([
    ])
    const [offerStatuses, setOfferStatuses] = useState([
        { value: 'live', label: 'Live' },
        { value: 'paused', label: 'Paused' },
    ]);
    const [formErrors, setFormErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [isPreloading, setIsPreLoaded] = useState(true);
    useEffect(() => {
        fetchOfferStatus();
        fetchJobs();
    }, []);

    const fetchJobs = async () =>{
        try{

            setIsPreLoaded(true);
            const jobs = await getJobs();

            setJobs(jobs.data.jobs)
            setIsPreLoaded(false);
        }catch(error){

        }
    }

    const fetchOfferStatus = async () => {
        try {
            const offertype = await getOfferStatus();
            console.log(offertype);
            setOfferStatuses(offertype.data.offerStatusFeed);
        } catch (error) {
            console.error('Error fetching advertisers:', error);
        }
    };
    const toggleModal = () => {
        setIsUpdate(false);
        setIsSubmitting(false);
        setNewCronjob({ title: "",
        schedule: "",
        hours: 0,
        minutes: 0, });
        setModalOpen(!modalOpen);
    };

    const toggleUpdateModal = (job) => {
        setNewCronjob(job);
        setIsSubmitting(false);
        setIsUpdate(true);
        setModalOpen(!modalOpen);
    };

    const fetchOfferTypes = async () => {
        try {
            const offertype = await getTrackingPanels();
            console.log(offertype);
            // setOfferTypeData(offertype.data.panelFeed);
        } catch (error) {
            console.error('Error fetching advertisers:', error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewCronjob((prevData) => ({ ...prevData, [name]: value }));



        setFormErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));

    };

    //   const generateShortName = (text) => {
    //     const words = text.trim().split(' ');
    //     let initials = '';

    //     if (words.length === 1) {
    //       const word = words[0].toUpperCase();
    //       if (word.length >= 2) {
    //         initials = word.substring(0, 2);
    //       } else {
    //         initials = word.padEnd(2, '_');
    //       }
    //     } else {
    //       words.forEach((word) => {
    //         initials += word.charAt(0).toUpperCase();
    //       });
    //     }
    //     setNewOfferType((prevData) => ({ ...prevData, shortName: initials }));
    //   };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        // Perform form validation
        const errors = {};
        if (newCronjob.title.trim() === '') {
            errors.title = 'title is required';

            if (Object.keys(errors).length > 0) {
                setFormErrors(errors);
                return;
            }
        } else {
            setIsSubmitting(true);
            try {
                console.log(newCronjob);
                const addJob = await addNewCronjob(newCronjob);
                console.log(addJob);
                setIsSubmitting(false);
                fetchJobs();
                // setOfferTypeData((prevData) => [...prevData, newOfferType]);
                // setNewOfferType({ tracking_panel_name: '', tracking_panel_postback: '' });
                toggleModal();
            } catch (error) {
                console.error('Error adding advertiser:', error);
            }
        }


    };
    const handleFormUpdate = async (e) => {
        e.preventDefault();

        // Perform form validation
        const errors = {};
        if (newCronjob.title.trim() === '') {
            errors.title = 'title is required';

            if (Object.keys(errors).length > 0) {
                setFormErrors(errors);
                return;
            }
        } else {
            setIsSubmitting(true);
            console.log(newCronjob);
            try {
                const addedAdvertiser = await updateJob(newCronjob.id, newCronjob);
                setIsSubmitting(false);
                setIsPreLoaded(true);
                fetchJobs();
                toggleModal();
            } catch (error) {
                console.error('Error adding advertiser:', error);
            }
        }


    };
    const handleDeleteOfferType = async (id) => {
        try {
            console.log(id);

            await deleteJob(id);
            setIsPreLoaded(true);
            fetchJobs();

            // await deleteTrackingPanel(id);
            // setOfferTypeData((prevData) => prevData.filter((advertiser) => advertiser.id !== id));
        } catch (error) {
            console.error('Error deleting advertiser:', error);
        }
    };

    return (
        <div className="d-flex align-items-center justify-content-center" >
      {isPreloading ? (
        <div
        className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
        style={{ background: 'rgba(0, 0, 0, 0.5)', zIndex: 9999, minHeight: '100vh' }}
      >
        <Spinner type="grow" color="primary" />
      </div>
  
    
      ) : (
        <div className="container-fluid py-4">
            <div className="row">
                <Card>
                    <CardHeader className="d-flex justify-content-between">
                        <h5>All Cronjobs</h5>
                        <Button color="primary" className='btn-sm ' onClick={toggleModal}>
                            <i className="ni ni-fat-add" /> Add New Conjob
                        </Button>
                    </CardHeader>

                    <div className="p-4">
                        <Table responsive className='table table-hover table-border '>
                            <thead className='thead-light'>
                                <tr>
                                    <th scope='col'>Job title</th>
                                    <th scope='col'>Job Value</th>
                                    <th scope='col'>Job Time</th>
                                    <th scope='col'>Status</th>
                                    <th scope='col'>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {jobslist.map((job, index) => (
                                    <tr key={index}>
                                        <td className='font-weight-bold'>

                                            <span>{job.title}</span>

                                        </td>
                                        <td>{job.schedule}</td>

                                        { job.hours >11 && (  <td>{job.hours}:{job.minutes} PM</td>)}
                                        { job.hours < 11 && (  <td>{job.hours}:{job.minutes} AM</td>)}

                                        {
                                            job.status === 'active' ?
                                            <td>
                                                <span className='badge bg-gradient-success text-white'>
                                                {job.status}
                                                </span>
                                            </td> :
                                            <td>
                                                <span className='badge bg-gradient-danger text-white'>
                                                {job.status}
                                                </span>
                                            </td>
                                        }
                                        

                                        <td class="text-sm">
                                            <Button color='success' className=" btn btn-sm mx-3 text-white" onClick={() => toggleUpdateModal(job)} >
                                                <i class="fas fa-user-edit " aria-hidden="true"></i>
                                            </Button>
                                            <Button color='danger' className='btn btn-sm text-white' onClick={() => handleDeleteOfferType(job.id)}>
                                                <i class="fas fa-trash" aria-hidden="true"></i>
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </Card>

                <Modal isOpen={modalOpen} toggle={toggleModal} size="md">
                    <ModalHeader toggle={toggleModal}>Add Cronjob</ModalHeader>
                    <ModalBody>
                        <form onSubmit={handleFormSubmit}>
                            <FormGroup>
                                <Label for="name">Title</Label>
                                <Input
                                    type="text"
                                    name="title"
                                    id="title"
                                    value={newCronjob.title}
                                    onChange={handleInputChange}
                                    invalid={!!formErrors.title}
                                />
                                {formErrors.title && <FormFeedback>{formErrors.title}</FormFeedback>}
                            </FormGroup>

                            <FormGroup>
                                <Label for="selectedOption">Offer Status</Label>
                                <InputGroup>
                                    <Input
                                        type="select"
                                        name="schedule"
                                        id="schedule"
                                        value={newCronjob.schedule}
                                        onChange={handleInputChange}
                                    >
                                        {offerStatuses.map((offerStatus, index) => (
                                            <option key={index} value={offerStatus.value}>
                                                {offerStatus.label}
                                            </option>
                                        ))}
                                    </Input>

                                </InputGroup>
                            </FormGroup>
                            <FormGroup>
                                <Label for="hours">Hours</Label>
                                <Input
                                    type="number"
                                    id="hours"
                                    min="0"
                                    max="23"
                                    name='hours'
                                    value={newCronjob.hours}
                                    onChange={handleInputChange}
                                    placeholder="Enter Hours"
                                    required
                                />
                            </FormGroup>

                            <FormGroup>
                                <Label for="minutes">Minutes</Label>
                                <Input
                                    type="number"
                                    id="minutes"
                                    min="0"
                                    max="59"
                                    name='minutes'
                                    value={newCronjob.minutes}
                                    onChange={handleInputChange}
                                    placeholder="Enter Minutes"
                                    required
                                />
                            </FormGroup>

                            {
                                isUpdate ?
                                <FormGroup>
                                <Label for="selectedOption">Offer Status</Label>
                                <InputGroup>
                                    <Input
                                        type="select"
                                        name="status"
                                        id="status"
                                        value={newCronjob.status}
                                        onChange={handleInputChange}
                                    >
                                        
                                            <option  value='active'>
                                                Active
                                            </option>
                                            <option  value='inactive'>
                                                In Active
                                            </option>
                                      
                                    </Input>

                                </InputGroup>
                            </FormGroup>
                            :
                            <FormGroup>
                                <Label>Status: Active</Label>
                            </FormGroup>
                            }

                        </form>
                    </ModalBody>
                    <ModalFooter>
                        {!isUpdate ?
                            <Button color="primary" onClick={handleFormSubmit} disabled={isSubmitting} >
                                {isSubmitting ? <Spinner size="sm" color="light" /> : 'Submit'}
                            </Button>
                            : <Button color="primary" onClick={handleFormUpdate} disabled={isSubmitting} >
                                {isSubmitting ? <Spinner size="sm" color="light" /> : 'Update'}
                            </Button>
                        }
                        <Button color="secondary" onClick={toggleModal}>
                            Close
                        </Button>

                    </ModalFooter>
                </Modal>
            </div>
        </div>
      )}
      </div>
    );
};

export default Cronjobs;
